class Quoting {
  constructor() {
    this.getQuote = this.getQuote.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.closeErrorPanel = this.closeErrorPanel.bind(this);
    this.geolocate = this.geolocate.bind(this);
    this.minQty = this.minQty.bind(this);
    this.prepQuote = this.prepQuote.bind(this);
    this.prepEmail = this.prepEmail.bind(this);
    this.fillPricingSection = this.fillPricingSection.bind(this);
    this.isValidZip = this.isValidZip.bind(this);
    this.isOutsideDefaultZip = this.isOutsideDefaultZip.bind(this);
    this.isCanadianPostalCode = this.isCanadianPostalCode.bind(this);
    this.isCanadianProduct = this.isCanadianProduct.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.hideErrorSection = this.hideErrorSection.bind(this);
    this.showErrorSection = this.showErrorSection.bind(this);
    this.flashErrorSection = this.flashErrorSection.bind(this);
    this.changeToSent = this.changeToSent.bind(this);
    this.changeToSend = this.changeToSend.bind(this);
    this.restoreEmailSendLink = this.restoreEmailSendLink.bind(this);
    this.updateQuotingId = this.updateQuotingId.bind(this);
    this.updateQuotingMinQty = this.updateQuotingMinQty.bind(this);
    this.updateQuotingDesignColorSelects = this.updateQuotingDesignColorSelects.bind(
      this
    );
    this.limitColors = this.limitColors.bind(this);
    this.enableColors = this.enableColors.bind(this);
    this.emailAddySelector = '.pc-Style-calculatePrice-inputEmail';
    this.validZip = /(^\d{5}(-\d{4})?$)|(^[a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d$)/;
    this.canadianZip = /(^[a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d$)/;
    this.validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.initBehavior();
    this.geolocate();
  }

  initBehavior() {
    $(document).on('swatchselect.style.colorinteraction', (e, data) => {
      this.updateQuotingId(e, data);
      this.updateQuotingMinQty(e, data);
      return this.updateQuotingDesignColorSelects(e, data);
    });
    $(document).on('keyup', this.emailAddySelector, (e) => {
      if (this.validationTimeout) {
        clearTimeout(this.validationTimeout);
      }
      return (this.validationTimeout = setTimeout(this.validateEmail, 700));
    });
    $(document).on('change.quoting', '.pc-Style-pricing-pricingFactor', (e) => {
      const currentQuantity = parseInt($("#quote_qty").val());
      const minimumQuantity = ProductCatalog.Quoting.minQty();
      if (currentQuantity > minimumQuantity) {
        const lessButton = $(".sb-Form-stepControl-less");
        lessButton.removeClass( "is-Disabled" );
      }

      this.hideErrorSection();
      this.volumeQty().val(
        Math.max(
          $('.pc-Style-pricingFactor-quantity').val() * 2,
          $('.pc-Style-calculatePrice-inputs input[name="bulk_qty"]').val()
        )
      );
      const zipcode = this.zipcodeField().val();
      if (this.quoteTimeout) {
        clearTimeout(this.quoteTimeout);
      }
      if (!this.isValidZip(zipcode)) {
        return this.showErrorSection(
          'Must use a valid U.S. or Canada postal code. Please try again.'
        );
      }
      return (this.quoteTimeout = setTimeout(this.prepQuote, 500));
    });
    $(document).on(
      'click.quoting',
      '.pc-Style-error-closeWrapper',
      this.closeErrorPanel
    );
    $(document).on(
      'change.quoting',
      '.pc-Style-pricingFactor-quotingInput',
      (e) => {
        if (this.quotingTagTimeout) {
          clearTimeout(this.quotingTagTimeout);
        }
        return (this.quotingTagTimeout = setTimeout(this.fireQuotingTag, 500));
      }
    );
    return $(document).on(
      'click',
      '.pc-Style-calculatePrice-sendEmail',
      this.prepEmail
    );
  }

  colors() {
    return $('.pc-Style-colors');
  }

  colorFront() {
    return $('.pc-Style-pricingFactor-front');
  }

  colorBack() {
    return $('.pc-Style-pricingFactor-back');
  }

  emailSend() {
    return $('.pc-Style-calculatePrice-sendEmail');
  }

  error() {
    return $('.pc-Style-error');
  }

  errorText() {
    return this.error().children().last();
  }

  priceEach() {
    return $('.pc-Style-calculatePrice-price-each');
  }

  priceTotal() {
    return $('.pc-Style-calculatePrice-price-total');
  }

  priceQty() {
    return $('.pc-Style-pricingFactor-quantity');
  }

  volumeQty() {
    return $('.pc-Style-pricingFactor-volumeQuantity');
  }

  productId() {
    return $('.pc-Style-pricing-pricingFactor-productId').val();
  }

  volumeDisc() {
    return $('.pc-Style-calculatePrice-volumeDiscount');
  }

  quoteQty() {
    return $('#quote_qty');
  }

  zipcodeField() {
    return $('.pc-Style-pricingFactor-zipcode');
  }

  // Private (AJAX)

  getQuote(quote_params) {
    const path = this.newQuotePath();
    return $.ajax(path, {
      type: 'GET',
      dataType: 'json',
      data: quote_params,
      error: (jqXHR, textStatus, errorThrown) => {
        return this.showErrorSection(
          "The information you've entered is not valid. Please try again."
        );
      },
      success: (data, textStatus, jqXHR) => {
        data.original.quantity = this.priceQty().val();
        data.original.color_counts_front = this.colorFront().val();
        data.original.color_counts_back = this.colorBack().val();
        if (data.volume) {
          data.volume.quantity = this.volumeQty().val();
        }
        $(document).trigger('updated.style.quoting', data);
        this.fillPricingSection(data);
        if (this.isValidEmail($(this.emailAddySelector).val())) {
          return this.restoreEmailSendLink();
        }
      }
    });
  }

  sendEmail(quote_params, pk) {
    const path = this.quotesPath();
    return $.ajax(path, {
      type: 'POST',
      dataType: 'json',
      data: quote_params,
      error: (jqXHR, textStatus, errorThrown) => {
        return this.showErrorSection(
          'Email could not be sent. Please confirm your email address and try again.'
        );
      },
      success: (data, textStatus, jqXHR) => {
        return this.changeToSent();
      }
    });
  }

  // Private (handler helpers)

  fireQuotingTag() {
    return CustomInk.Metrics.fireEvent('get quote', 'price update', null);
  }

  newQuotePath() {
    const meta = $('meta[property=newquotepath]');
    if (!(meta.length > 0)) {
      return undefined;
    }
    return meta.attr('content');
  }

  quotesPath() {
    const meta = $('meta[property=quotespath]');
    if (!(meta.length > 0)) {
      return undefined;
    }
    return meta.attr('content');
  }

  closeErrorPanel(e) {
    e.preventDefault();
    return this.hideErrorSection();
  }

  geolocate() {
    let zipcode;
    if (!this.zipcodeField().length) {
      return;
    }
    const geolocation = ProductCatalog.Pricing.zipcode();
    if (geolocation && this.isOutsideDefaultZip(geolocation) && !this.isPla()) {
      zipcode = geolocation;
    }
    if (this.isCanadianProduct() && !this.isCanadianPostalCode(geolocation)) {
      zipcode = 'M5V 0G9';
    }
    if (zipcode) {
      this.zipcodeField().val(zipcode);
      return this.prepQuote();
    }
  }

  minQty() {
    return parseInt(this.quoteQty().attr('min'), 10);
  }

  prepQuote(e) {
    const priceQty = this.priceQty();
    if (
      !priceQty.val() ||
      priceQty.val() === '' ||
      priceQty.val() < this.minQty()
    ) {
      priceQty.val(this.minQty());
      this.volumeQty().val(this.minQty() * 2);
      this.flashErrorSection(
        "The quantity you've entered is lower than the minimum allowed for this item. We've reset your quote to the minimum allowable quantity."
      );
    }
    const quote_params = $('.pc-Form').serialize();
    return this.getQuote(quote_params);
  }

  prepEmail(e) {
    e.preventDefault();
    const quote_params = $('.pc-Form').serialize();
    this.sendEmail(quote_params);
    return CustomInk.Metrics.fireEvent('get quote', 'email quote', null);
  }

  fillPricingSection(data) {
    this.priceEach().text('$' + data.original.each);
    this.priceTotal().text('$' + data.original.total);
    return this.volumeDisc().text(
      '$' +
        data.volume.each +
        ' each for ' +
        this.commaFormatted(data.volume.quantity) +
        ' items'
    );
  }

  commaFormatted(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  isValidZip(zipcode) {
    if (!zipcode) {
      return;
    }
    return zipcode.match(this.validZip);
  }

  isOutsideDefaultZip(zipcode) {
    return zipcode !== this.zipcodeField().val();
  }

  isCanadianPostalCode(zipcode) {
    return String(zipcode).match(this.canadianZip);
  }

  isCanadianProduct() {
    return $('.pc-Style').data('canadian');
  }

  isPla() {
    return $('pc-Style.is-pla').length;
  }

  isValidEmail(email) {
    if (!email) {
      return;
    }
    return email.match(this.validEmail);
  }

  validateEmail() {
    const email = $('.pc-Style-calculatePrice-inputEmail').val();
    if (!this.isValidEmail(email)) {
      return this.showErrorSection('Must use a valid email address.');
    }
    this.emailSend().removeClass('is-Disabled');
    this.hideErrorSection();
    return this.restoreEmailSendLink();
  }

  hideErrorSection() {
    return this.error().fadeOut();
  }

  showErrorSection(msg) {
    this.errorText().text(msg);
    this.error().show();
    return this.emailSend().addClass('is-Disabled');
  }

  flashErrorSection(msg) {
    this.errorText().text(msg);
    this.error().show();
    return setTimeout(this.hideErrorSection, 5000);
  }

  changeToSent() {
    const emailSend = this.emailSend();
    emailSend.text('Email Sent!');
    emailSend.addClass('is-Disabled');
    return emailSend.click((e) => {
      return e.preventDefault();
    });
  }

  changeToSend() {
    const emailSend = this.emailSend();
    emailSend.text('Send');
    return emailSend.removeClass('is-Disabled');
  }

  restoreEmailSendLink() {
    return this.changeToSend();
  }

  updateQuotingId(e, data) {
    return $('#quote_pk').val(data.colorid).trigger('change');
  }

  updateQuotingMinQty(e, data) {
    return this.quoteQty().attr('min', data.minQty);
  }

  updateQuotingDesignColorSelects(e, data) {
    const selects = $('.pc-Style-pricingFactor-designColor');
    if (!data.singlesEnabled && this.priceQty().val() < 48) {
      return this.limitColors(selects);
    } else {
      return this.enableColors(selects);
    }
  }

  limitColors(selects) {
    return Array.from(selects).map((select, i) =>
      (() => {
        return this.disableAndResetSelectOptions(select);
      })()
    );
  }

  enableColors(selects) {
    return Array.from(selects).map((select, i) =>
      (() => {
        return this.enableSelectOptions(select);
      })()
    );
  }

  disableAndResetSelectOptions(select) {
    const $el = $(select);
    const $optionsToToggle = $el.children('option').filter(function () {
      return parseInt(this.value, 10) > 4;
    });
    const currentVal = parseInt($el.val(), 10);
    if (currentVal > 4) {
      $el.val(4);
    }
    return $optionsToToggle.prop('disabled', true);
  }

  enableSelectOptions(select) {
    return $(select)
      .children('option')
      .filter(function () {
        return parseInt(this.value, 10) > 4;
      })
      .prop('disabled', false);
  }
}

jQuery(() => (ProductCatalog.Quoting = new Quoting()));
